import { requestQueue } from "./requestQueue"

async function patchRequest(url = '', data = {}) {
  const seed = Math.random()
   requestQueue.push(seed)

  try {
  const response = await fetch(url, {
    method: 'PATCH',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data)
  })
  requestQueue.pop(seed)
  return response.json()
  } catch (e) {
    console.error(e)
    requestQueue.pop(seed)
    return {}
  }
}

export default patchRequest

